import { AppThunkDispatch } from '@Reducers/index';

import { ReceiptsApi } from '@ClientServices/api/receiptsApi';
import { IEmailReceiptModel } from '@Shared/models';

export const SET_RECEIPTS = 'SET_RECEIPTS';
export const SET_RECEIPTS_LOADING = 'SET_RECEIPTS_LOADING';
export const SET_SKIPPED_RECEIPTS = 'SET_SKIPPED_RECEIPTS';

export class SetReceipts {
  readonly type = SET_RECEIPTS;
  constructor(public payload: IEmailReceiptModel[]) {}
}

export class SetReceiptsLoading {
  readonly type = SET_RECEIPTS_LOADING;
  constructor(public payload: boolean) {}
}
export class SetSkippedReceipts {
  readonly type = SET_SKIPPED_RECEIPTS;
  constructor(public payload: IEmailReceiptModel[]) {}
}

export const getReceipts = () => async (dispatch: AppThunkDispatch) => {
  dispatch(new SetReceiptsLoading(true));
  const receipts = await ReceiptsApi.getAll();
  dispatch(new SetReceipts(receipts));
};

export type ReceiptsAction = SetReceipts | SetReceiptsLoading | SetSkippedReceipts;
